(() => {
  const modal = document.querySelector('[data-pp-welcome-popup]');
  if (!modal) return;

  const params = new URLSearchParams(window.location.search);
  const force = params.get('pp_popup'); // "1" force open, "0" force disable
  if (force === '0') return;

  const delaySeconds = Math.max(0, parseInt(modal.dataset.delaySeconds || '2', 10) || 0);
  const frequencyDays = Math.max(0, parseInt(modal.dataset.frequencyDays || '14', 10) || 0);

  const storageKey = 'pp_welcome_popup_seen_at_v1';
  const now = Date.now();

  function canUseStorage() {
    try {
      localStorage.setItem('__pp_test__', '1');
      localStorage.removeItem('__pp_test__');
      return true;
    } catch (e) {
      return false;
    }
  }

  function getLastSeen() {
    if (!canUseStorage()) return null;
    const raw = localStorage.getItem(storageKey);
    const ts = raw ? parseInt(raw, 10) : NaN;
    return Number.isFinite(ts) ? ts : null;
  }

  function setLastSeen(ts) {
    if (!canUseStorage()) return;
    try {
      localStorage.setItem(storageKey, String(ts));
    } catch (e) {}
  }

  function shouldShow() {
    if (force === '1') return true;
    const lastSeen = getLastSeen();
    if (lastSeen == null) return true;
    if (frequencyDays === 0) return false; // once per browser
    const windowMs = frequencyDays * 24 * 60 * 60 * 1000;
    return now - lastSeen > windowMs;
  }

  function open() {
    if (modal.hasAttribute('open')) return;
    // Mark as seen when we open (prevents repeated popups if user reloads without closing).
    setLastSeen(Date.now());
    if (typeof modal.show === 'function') modal.show(null);
  }

  if (!shouldShow()) return;

  window.setTimeout(() => {
    // Avoid popping while browser tab is hidden (common on mobile deep-links).
    if (document.hidden) return;
    open();
  }, delaySeconds * 1000);
})();


